import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getAdminRole } from "../utils/auth";
import { hasAccess, getFirstAllowedPath, } from "../utils/permissions";
const PrivateRoute = ({ children, resource }) => {
    if (!isAuthenticated()) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    if (resource) {
        const role = getAdminRole();
        if (!hasAccess(role, resource)) {
            return _jsx(Navigate, { to: getFirstAllowedPath(role), replace: true });
        }
    }
    return children;
};
export default PrivateRoute;
